import { createBrowserLogger } from '@aira/observability/browser';

/**
 * Structured logger for the Outlook task pane. Emits the same log-entry shape as
 * the backend / Gmail Node loggers (severity, service, correlation/session id,
 * ...) but through the browser `console` — pino cannot run in the browser.
 * PII/secrets in fields are scrubbed by the shared `scrub()`. Local only; not
 * forwarded. A per-session id ties a user's log lines together.
 */
export const logger = createBrowserLogger({
  service: 'aira-outlook-addin',
  sessionId: globalThis.crypto?.randomUUID?.(),
});
